import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <p>
        © 2020 <strong>BOYKA</strong>!{" "}
      </p>
      <p>Privacy · Terms · Sitemap · Company Details</p>
    </div>
  );
}

export default Footer;
